<template>
    <div>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-dark">
                <!-- Insert Image Here -->
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="pl-0">
                            <h4 class="display-3 text-white">Support Our Ministry</h4>
                            <p class="text-white">Contribute to His purpose through your generosity.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-shaped section-lg my-0">
            <div class="container">
                <div class="row justify-content-center mb-4">
                    <div class="col-lg-12 mb-4">
                        <h2 class="display-3 ">Ways To Give</h2>
                        <p class="lead">
                            We believe that giving is an act of worship and a way to honor God with the blessings He has entrusted to us. Your offerings enable us to expand our outreach programs, maintain our facilities, and provide vital resources to our community. 'Honor the Lord with your wealth, with the firstfruits of all your crops' (Proverbs 3:9). We are grateful for your obedience and generosity, which allows us to further His kingdom
                        </p>
                        <div class="row">
                            <div class="col-lg-8 mt-4">
                                <p class="lead">
                                    <img src="img/icons/gcash-logo.png" alt="Giving" class="img-fluid" style="width: 50%;" />
                                </p>
                            </div>
                            <div class="col-lg-6">
                                <p>
                                    Scan this QR code with your phone to give through GCash instantly. <br/>
                                    <img src="img/icons/gcash-account.jfif" style="width: 50%;" class="img-fluid rounded shadow mt-4" alt="Church GCash Account" />
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 mt-4">
                        <h2 class="display-3 ">Other Giving Methods</h2>
                        <p class="lead">
                            For bank transfer donations, please reach out to <b>Irish Idurot</b>, our church secretary. She can provide you with the bank account information. You can contact her at 
                            <a href="mailto:irishidurot@gmail.com">irishidurot@gmail.com</a>.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "giving",
    components: {}
};
</script>

<style scoped>
.gcash-number {
    font-weight: bold;
    font-size: 2.5rem;
    color: #212329;
}
</style>
